import React from "react"
import PageBanner from "../PageBanner"
import PropTypes from "prop-types"
import { ComplianceCircle } from "@swipesense/compliance-helpers"
import HelpToolTip from "@swipesense/help-tooltip"
import "./CaseBanner.scss"

const CaseBanner = (props) => {
  return (
    <PageBanner className="CaseBanner">
      <div className="left">
        <h1>
          {props.employeeName
            ? `${props.employeeName}`
            : `Case #${props.caseId}`}
        </h1>
      </div>
      {props.role && props.department && (
        <div className="right">
          {props.employeeId && (
            <div className="employeeId">ID: {props.employeeId}</div>
          )}
          <div className="role">{props.role}</div>
          <div className="department">{props.department}</div>
          {props.compliance && (
            <div className="compliance">
              <div className="top-text">
                COMPLIANCE
                <HelpToolTip placement="auto">
                  Overall hand hygiene compliance for duration of exposure time
                  period.
                </HelpToolTip>
              </div>
              <div className="circle">
                <ComplianceCircle compliance={props.compliance} />
                {props.compliance.toFixed(0)}%
              </div>
            </div>
          )}
        </div>
      )}
    </PageBanner>
  )
}

CaseBanner.propTypes = {
  caseId: PropTypes.string.isRequired,
  employeeName: PropTypes.string,
  employeeId: PropTypes.string,
  role: PropTypes.string,
  department: PropTypes.string,
  compliance: PropTypes.number,
}

export default CaseBanner
